import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { NewsBannerSlideModel } from '../../../models/news-banner.model';

@Component({
  selector: 'app-news-dialog',
  templateUrl: './news-dialog.component.html',
  styleUrl: './news-dialog.component.scss',
  standalone: false,
})
export class NewsDialogComponent {
  public newsBannerSlide: NewsBannerSlideModel;

  constructor(
    private dialogRef: DynamicDialogRef,
    private config: DynamicDialogConfig
  ) {
    this.newsBannerSlide = this.config.data;
  }
}
